import { isValidPulseIdentity } from './PulseIdentity';
export const pulseIdentityApiToEntity = pulseIdentity => {
  if (!pulseIdentity) {
    throw new Error('Invalid pulse identity', {
      cause: {
        pulseIdentity
      }
    });
  }
  const converted = {
    id: pulseIdentity.id,
    revision: pulseIdentity.revision,
    createdDate: pulseIdentity.createdDate ? new Date(pulseIdentity.createdDate) : undefined,
    updatedDate: pulseIdentity.updatedDate ? new Date(pulseIdentity.updatedDate) : undefined,
    name: pulseIdentity.name,
    description: pulseIdentity.description,
    soul: pulseIdentity.soul,
    heartbeat: pulseIdentity.heartbeat,
    persistedFiles: pulseIdentity.persistedFiles,
    triggers: pulseIdentity.triggers,
    cron: pulseIdentity.cron,
    autoMode: pulseIdentity.autoMode
  };
  if (isValidPulseIdentity(converted)) {
    return converted;
  }
  throw new Error('Invalid pulse identity data', {
    cause: {
      converted
    }
  });
};
export const pulseIdentityEntityToApi = entity => ({
  id: entity.id,
  revision: entity.revision,
  name: entity.name,
  description: entity.description,
  soul: entity.soul,
  heartbeat: entity.heartbeat,
  persistedFiles: entity.persistedFiles,
  triggers: entity.triggers,
  cron: entity.cron ?? undefined,
  autoMode: entity.autoMode
});
//# sourceMappingURL=converters.js.map